import React, { useState } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";

import {
	TrackingButtonProps,
	TrackingButtonState,
} from "./TrackingButton.types";
import {
	StyledSelectedIcon,
	StyledUnselectedIcon,
	StyledInput,
} from "./TrackingButton.styles";
import Box from "../../layout/boxes/Box";

const TrackingButton = ({
	onChange,
	selected = false,
	id,
	label,
	className,
	...props
}: TrackingButtonProps) => {
	const block = new BemIt("TrackingButton");

	const [trackingButtonState, setTrackingButtonState] =
		useState<TrackingButtonState>({
			selectedIconClassName: block.el("icon").mod({
				selected: selected,
			}).out,
			selected,
		});

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setTrackingButtonState((prevState: TrackingButtonState) => {
			const newSelectedState = !prevState.selected;

			onChange(newSelectedState, e, id);

			return {
				...prevState,
				selectedIconClassName: block.el("icon").mod({
					"scale-down": prevState.selected,
					"scale-up": newSelectedState,
					selected: newSelectedState,
				}).out,
				selected: newSelectedState,
			};
		});
	};

	return (
		<Box
			className={addClass(className).after(block)}
			position="relative"
			width="32px"
			height="32px"
			{...props}
		>
			{label && (
				<label htmlFor={id} hidden>
					{label}
				</label>
			)}
			<StyledUnselectedIcon tabIndex={-1} name="star" size="lg" />
			<StyledSelectedIcon
				className={trackingButtonState.selectedIconClassName}
				tabIndex={-1}
				name="star"
				size="lg"
				color="semantic_warning"
			/>
			<StyledInput id={id} type="checkbox" onChange={handleChange} />
		</Box>
	);
};

export default TrackingButton;
